<template>
  <v-container fluid grid-list-lg>
    <page-loading v-show="loading"></page-loading>
    <v-layout wrap>
      <p v-if="!loading && noutati.length === 0">Nu exista articole...</p>
      <v-flex xs12 v-for="noutate in noutati" :key="noutate.id">
        <v-card :to="{name:'noutati.show', params: {id: noutate.id}}" :class="{'grey--text': noutate.citita}">
          <v-card-title>
            <div>
              <h3>
                <em v-if="noutate.citita">{{ noutate.titlu }}</em>
                <span v-else>{{ noutate.titlu }}</span>
                <v-chip v-if="!noutate.citita" color="red" text-color="white" disabled small>Necitit</v-chip>
              </h3>
              <div>{{ noutate.rezumat }}</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :to="{name:'noutati.show', params: {id: noutate.id}}" small color="primary">{{ lang.mai_mult_label }}...
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex v-if="hasNextPage">
        <p class="text-xs-center">
          <v-btn @click.prevent="loadMore" :loading="loading">{{ lang.mai_incarca_label }}</v-btn>
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import kw from '@/modules/noutati/lang/index.js';
  import { mapState } from 'vuex';
  import { index } from '@/modules/noutati/index.js';

  export default {
    props: {
      tip: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        hasNextPage: false,
        page: 1,
        loading: false,
        data: []
      }
    },
    computed: {
      ...mapState({
        language: s => s.lang.lang,
        alreadyRead: s => s.noutati.read,
      }),
      lang() {
        return kw[this.language];
      },
      noutati() {
        return this.data.map(noutate => ({ ...noutate, citita: this.alreadyRead.includes(noutate.id) }));
      }
    },
    methods: {
      refresh() {
        this.page = 1;
        this.data = [];
        return this.load();
      },
      loadMore() {
        this.page++;
        return this.load();
      },
      load() {
        this.loading = true;

        return index(this.language, this.tip, { page: this.page })
          .then(r => r.json()
            .then(payload => {
              this.data = this.data.concat(payload.data);
              this.hasNextPage = payload.next_page_url !== null;
            })
          )
          .catch(e => {
              console.log(e);
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
    mounted() {
      this.load();
      this.$store.dispatch('noutati/updateLastAccessed', this.tip);
    },
  }
</script>
